var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriAjout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 216.3 192.8",
    style: {
      enableBackground: "new 0 0 216.3 192.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D61983;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.1,191.3c-3,0-6-1.1-8.2-3.1c-8.6-7.5-16.9-14.6-24.2-20.9l0,0c-21.5-18.3-40-34.1-53-49.7 C8.2,100.2,1.5,83.7,1.5,65.6c0-17.5,6-33.7,17-45.5C29.4,8.1,44.9,1.4,61,1.5c12.2-0.1,24,4,33.5,11.6c5.2,4,9.7,8.8,13.6,14.1 c3.8-5.3,8.4-10.1,13.6-14.1c9.5-7.5,21.4-11.6,33.5-11.6c16.2-0.1,31.7,6.6,42.6,18.6c10.9,11.8,17,28,17,45.5 c0,18-6.7,34.6-21.1,52c-12.9,15.6-31.5,31.4-53,49.7c-7.3,6.2-15.7,13.3-24.3,20.9C114.1,190.2,111.1,191.3,108.1,191.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriAjout);
export default __webpack_public_path__ + "static/media/favori-ajout.926edd6e198f3fe9c91569227a78b536.svg";
export { ForwardRef as ReactComponent };